/* dusa: cart drawer/page extras
   - "Finish the entry": the Add button on a one-size add-on adds it and re-renders
     the drawer. The list itself is server-rendered (snippets/cart-drawer.liquid) and
     replaced the Shopify "related" recommendations, which offered coir rolls.
   - Cart page: flags html.dusa-checkout-visible while Check out or the express
     buttons are on screen, so dusa-cart.css can hide the Shopify Inbox launcher
     that otherwise sits on the right of Check out on phones. */
(function () {
  'use strict';

  function addAddon(button) {
    var drawer = document.querySelector('cart-drawer');
    var variantId = button.getAttribute('data-dusa-addon-variant');
    if (!drawer || !variantId || button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: drawer.getSectionsToRender().map(function (section) {
          return section.id;
        }),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return r.json();
      })
      .then(function (state) {
        drawer.renderContents(state);
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        window.location.href = button.closest('.dusa-rec').querySelector('a').href;
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-dusa-addon-variant]');
    if (button) addAddon(button);
  });

  var checkoutObserver = null;
  var watched = [];

  function watchCartCheckout() {
    var targets = Array.prototype.slice.call(
      document.querySelectorAll('#main-cart-footer #checkout, #main-cart-footer .cart__dynamic-checkout-buttons')
    );
    var same =
      targets.length === watched.length &&
      targets.every(function (target, i) {
        return target === watched[i];
      });
    if (same || !('IntersectionObserver' in window)) return;
    if (checkoutObserver) checkoutObserver.disconnect();
    document.documentElement.classList.remove('dusa-checkout-visible');
    watched = targets;
    if (!targets.length) return;
    var onScreen = new Map();
    checkoutObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        onScreen.set(entry.target, entry.isIntersecting);
      });
      var any = false;
      onScreen.forEach(function (visible) {
        if (visible) any = true;
      });
      document.documentElement.classList.toggle('dusa-checkout-visible', any);
    });
    targets.forEach(function (target) {
      checkoutObserver.observe(target);
    });
  }

  function initCartPage() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    watchCartCheckout();
    // A quantity change re-renders the footer (assets/cart.js), replacing the buttons.
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        watchCartCheckout();
      });
    }).observe(footer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPage);
  } else {
    initCartPage();
  }
})();
